import { Route, Routes } from 'react-router';

import Create from './Create';
import Detail from './Detail';
import Overview from './Overview';

export default function InvoicesRoutes() {
  return (
    <Routes>
      <Route index element={<Overview />} />
      <Route path="/new" element={<Create />} />
      <Route path="/:id" element={<Detail />} />
    </Routes>
  );
}
